import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HelpIcon from '@material-ui/icons/Help';
import Close from '@material-ui/icons/Close';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import classNames from 'classnames';
import CardMedia from "@material-ui/core/es/CardMedia/CardMedia";

var FontAwesome = require('react-fontawesome');

const styles = {
    list: {
        width: 300,
        'ul': {
            padding: 0
        }
    },
    element: {
        paddingTop: '0.6em',
        paddingBottom: '0.6em'
    },
    fullList: {
        width: 'auto',
    },
    faIcon: {
        width: '24px',
        textAlign: 'center'
    }
};

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

function CardMediaLink(props) {
    return <CardMedia button component="a" {...props} />;
}


class CelesteMenu extends React.Component {

    render() {
        const {
            helpAction,
            toggleMenuAction,
            open
        } = this.props;

        const {classes} = this.props;

        const sideList = (
            <div className={classes.list}>
                <Close style={{
                    right: 0,
                    position: 'absolute',
                    margin: '0.1em',
                    cursor: 'pointer',
                    padding: '0.1em'
                }}
                       onClick={toggleMenuAction}/>

                <CardMediaLink
                    className={classes.media}
                    image="logo_celeste.png"
                    title="Celeste.fr"
                    style={{
                        width: '100%',
                        height: '125px',
                        backgroundSize: '160px',
                    }}
                    href={"https://www.celeste.fr/"}
                />
                <Divider/>
                <List>
                    <ListItemLink button key="mission" className={classes.element}
                                  href={"https://www.celeste.fr/societe/qui-sommes-nous"} target={"_blank"}>
                        <ListItemIcon>
                            <FontAwesome
                                className={classNames('super-crazy-colors', classes.faIcon)}
                                name='award'
                                style={{textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'}}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Qui sommes-nous ?"/>
                    </ListItemLink>
                </List>
                <List>
                    <ListItemLink button key="fibre" className={classes.element}
                                  href={"https://www.celeste.fr/fibre-optique"} target={"_blank"}>
                        <ListItemIcon>
                            <FontAwesome
                                className={classNames('super-crazy-colors', classes.faIcon)}
                                name='bezier-curve'
                                style={{textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'}}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Notre Fibre CELESTE"/>
                    </ListItemLink>
                </List>
                <List>
                    <ListItemLink button key="recordement" className={classes.element}
                                  href={"https://www.celeste.fr/connexions-et-reseaux"} target={"_blank"}>
                        <ListItemIcon><DeviceHubIcon/></ListItemIcon>
                        <ListItemText primary="Nos solutions de connexions et réseaux"/>
                    </ListItemLink>
                </List>
                <List>
                    <ListItemLink button key="actu" className={classes.element}
                                  href={"https://www.celeste.fr/contact"} target={"_blank"}>
                        <ListItemIcon>
                            <FontAwesome
                                className={classNames('super-crazy-colors', classes.faIcon)}
                                name='address-card'
                                style={{textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'}}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Contactez-nous"/>
                    </ListItemLink>
                </List>
                <List>
                    <ListItemLink button key="actu" className={classes.element}
                                  href={"https://www.celeste.fr/societe/le-blog"} target={"_blank"}>
                        <ListItemIcon>
                            <FontAwesome
                                className={classNames('super-crazy-colors', classes.faIcon)}
                                name='globe-europe'
                                style={{textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'}}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Nos Actualités"/>
                    </ListItemLink>
                </List>
                <List>
                    <ListItemLink button key="ref_client" className={classes.element}
                                  href={"https://www.celeste.fr/clients"} target={"_blank"}>
                        <ListItemIcon>
                            <FontAwesome
                                className={classNames('super-crazy-colors', classes.faIcon)}
                                name='handshake'
                                style={{textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'}}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Références clients"/>
                    </ListItemLink>
                </List>
                <Divider/>
                <List>
                    <ListItem button key="Help" onClick={helpAction} className={classes.element}>
                        <ListItemIcon><HelpIcon/></ListItemIcon>
                        <ListItemText primary="Aide"/>
                    </ListItem>
                </List>
            </div>
        );

        return (
            <div>
                <Drawer open={open} onClose={toggleMenuAction(false)}>
                    <div
                        tabIndex={0}
                        role="button"
                        onClick={toggleMenuAction(false)}
                        onKeyDown={toggleMenuAction(false)}
                    >
                        {sideList}
                    </div>
                </Drawer>
            </div>
        );
    }
}

CelesteMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CelesteMenu);